module.exports = __webpack_public_path__ + "images/5012b7ec552da1b6914b7a51d6466b11.gif";